import type { FC, ReactElement, ReactNode } from 'react';

import type { TrophyDisplayData } from '../../../store/slices/promotions/types';
import { useModifiers } from '../../../styles/hooks/useModifiers';
import { Tooltip } from '../../tooltip/Tooltip';

import styles from './gameWingItem.module.css';

export enum DirectionProps {
  end = 'end',
  start = 'start',
}
interface GameWingItemProps {
  action?: ReactNode;
  dataTestId?: string;
  direction?: DirectionProps;
  label?: ReactNode | string;
  trophy?: TrophyDisplayData;
  value?: ReactNode | string;
  isLabelAlignedRight?: boolean;
}

export const GameWingItem: FC<GameWingItemProps> = ({
  action,
  dataTestId,
  direction,
  label,
  trophy,
  value,
  isLabelAlignedRight,
}): ReactElement => {
  const mods = useModifiers(styles, 'gameWingItem', {
    end: direction === DirectionProps.end,
    start: direction === DirectionProps.start,
    trophyActive: trophy?.visibility === 'active',
    trophyInactive: trophy?.visibility === 'inactive',
  });

  const labelMods = useModifiers(
    styles,
    'gameWingItem__label',
    {
      right: isLabelAlignedRight,
    },
    { withBaseClass: true }
  );

  let trophyIcon = <></>;
  switch (trophy?.visibility) {
    case 'active':
      trophyIcon = <span className={styles.gameWingItem__trophy_active}></span>;
      break;
    case 'inactive':
      trophyIcon = (
        <Tooltip
          attrs={[trophy.minBet]}
          displayOnTouch
          displayTimer={5000}
          displayTrigger={trophy.showTrophyTooltip}
          text={trophy.isRoundLimitExceed ? 'DAILY_TOURNAMENT_LIMIT' : 'PROMO_BET_BELOWMIN'}
        >
          <span className={styles.gameWingItem__trophy_inactive}></span>
        </Tooltip>
      );
      break;
  }

  return (
    <div className={`${styles.gameWingItem} ${mods}`} data-testid={dataTestId ? `${dataTestId}` : 'game-wing-item'}>
      {action ? <div className={styles.gameWingItem__action}>{action}</div> : null}
      <div className={styles.gameWingItem__group}>
        {label ? (
          <div className={labelMods} data-testid={dataTestId ? `${dataTestId}-label` : 'label'}>
            {trophyIcon}
            {label}
          </div>
        ) : null}
        {value ? (
          <div className={styles.gameWingItem__value} data-testid={dataTestId ? `${dataTestId}-value` : 'value'}>
            {value}
          </div>
        ) : null}
      </div>
    </div>
  );
};
